// Mock data for EYCO products and content

export const products = [
  {
    id: 1,
    title: "High Oleic Refined Sunflower Oil\n(Conventional / Organic)",
    shortDesc: "Premium quality high oleic sunflower oil for superior cooking and food applications",
    description: "Our High Oleic Refined Sunflower Oil is specially processed to provide exceptional stability and nutritional benefits. With over 80% oleic acid content, it offers superior oxidative stability, making it ideal for high-temperature cooking and extended shelf life applications.",
    image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/irrt4ktw_High%20oleic%20.jpeg",
    features: [
      "High oleic acid content (>80%)",
      "Excellent oxidative stability",
      "Perfect for high-temperature cooking",
      "Extended shelf life",
      "Light flavor and color",
      "Non-GMO certified"
    ],
    applications: ["Food manufacturing", "Restaurant cooking", "Frying applications", "Salad dressings"],
    organicVariants: [
      {
        type: "Organic Refined High Oleic Sunflower Oil",
        description: "Premium organic refined high oleic sunflower oil meeting stringent international organic standards",
        certifications: ["EU Organic Standards", "NOP (USDA) Organic Standards"],
        image: "https://images.unsplash.com/photo-1717056577965-194f5228a09d?w=800&q=80",
        features: [
          "Certified organic by EU and NOP standards",
          "Non-GMO verified",
          "No synthetic pesticides or fertilizers",
          "Traceable supply chain",
          "High oleic acid content (>80%)"
        ]
      },
      {
        type: "Crude High Oleic Sunflower Oil (Organic)",
        description: "Unrefined organic crude high oleic sunflower oil preserving natural nutrients and characteristics",
        certifications: ["EU Organic Standards", "NOP (USDA) Organic Standards"],
        image: "https://images.unsplash.com/photo-1642189941430-7073f85d7140?w=800&q=80",
        features: [
          "Certified organic by EU and NOP standards",
          "Minimally processed crude oil",
          "Natural antioxidants preserved",
          "Rich in tocopherols",
          "Ideal for further processing"
        ]
      }
    ]
  },
  {
    id: 2,
    title: "Vegetable Distilled Fatty Acid",
    shortDesc: "Industrial-grade fatty acid distillate for various manufacturing applications",
    description: "High-quality Vegetable Distilled Fatty Acid produced through advanced distillation processes. This product is essential for soap manufacturing, animal feed supplements, and various industrial applications requiring fatty acid components. Available in multiple formulations to meet your specific needs.",
    image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/3sjpf1w4_distilled%20fatty%20acid%20.png",
    features: [
      "High purity distillate",
      "Tocopherol levels: 1.5% to 6%",
      "Suitable for Vitamin E producers",
      "Available in multiple formulations",
      "Consistent quality",
      "Excellent fatty acid profile",
      "Cost-effective solution",
      "Sustainable sourcing",
      "Bulk availability"
    ],
    applications: ["Soap manufacturing", "Animal feed", "Industrial lubricants", "Cosmetics industry", "Vitamin E production"],
    productVariants: [
      "Distilled fatty acid 100% sunflower",
      "Distilled fatty acid sunflower&Soybean mix",
      "Distilled fatty acid sunflower&Soybean&Palm mix",
      "Hazelnut Fatty Acid"
    ],
    specialNotes: {
      title: "Vitamin E Production Ready",
      description: "Our Vegetable Distilled Fatty Acid features tocopherol levels ranging from 1.5% to 6%, making it an ideal raw material for Vitamin E producers. Available in 100% pure sunflower oil variant or as mixed formulation to meet your specific production requirements."
    }
  },
  {
    id: 3,
    title: "Vegetable Acid Oil",
    shortDesc: "Versatile acid oil for industrial and manufacturing processes",
    description: "Our Vegetable Acid Oil is a by-product of the refining process, rich in free fatty acids and valuable for numerous industrial applications. It provides an economical and sustainable solution for various manufacturing needs.",
    image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/k8u2jqlz_acid%20oil.jpg",
    features: [
      "High free fatty acid content",
      "Sustainable by-product",
      "Cost-effective",
      "Consistent specifications",
      "Various grade options",
      "Reliable supply chain"
    ],
    applications: ["Biodiesel production", "Animal feed industry", "Soap making", "Oleochemical industry"]
  },
  {
    id: 4,
    title: "Olive Squalene",
    shortDesc: "Nature's finest emollient - 100% plant-based squalene from pure olive oil",
    description: "Derived from pure olive oil, our Olive Squalene is one of nature's most versatile and skin-compatible compounds. As an acyclic hydrocarbon (C₃₀H₅₀) naturally found in human sebum, squalene integrates seamlessly with the body's own biology — making it a prized ingredient in cosmetics, nutraceuticals, and specialty formulations worldwide.",
    image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/dlfm53mg_olive%20squalene.jpg",
    features: [
      "100% plant-based and non-petroleum origin",
      "Superior oxidative stability",
      "Lightweight, odorless, and fast-absorbing",
      "Exceptional purity (>90%)",
      "Low acidity and minimal peroxide value",
      "Cloud point at or below 10°C",
      "Nitrogen-packaged for freshness",
      "Two-year shelf life"
    ],
    applications: ["Cosmetics industry", "Pharmaceutical applications", "Nutraceuticals", "Food-grade formulations", "Skincare products"],
    qualitySpecs: {
      title: "Premium Quality Standards",
      description: "Our olive-origin squalene delivers exceptional purity (>90%) with a low acidity, minimal peroxide value, and a cloud point at or below 10°C — meeting the strictest quality benchmarks. Every batch is nitrogen-packaged to preserve freshness, with a two-year shelf life."
    },
    packaging: {
      bulk: [
        {
          type: "Flexi Tanks",
          description: "Flexible bulk liquid containers for large-scale distribution",
          capacity: "Up to 24,000 liters"
        },
        {
          type: "IBC Tanks",
          description: "Intermediate Bulk Containers for safe, efficient storage and transport",
          capacity: "1,000 liters standard"
        }
      ]
    },
    pdfSpec: {
      title: "Olive Squalene Technical Specifications",
      description: "Download detailed technical specifications, quality parameters, and application guidelines",
      file: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/em3xuidp_Olive%20squalene%20specs.pdf"
    }
  },
  {
    id: 5,
    title: "Refined Edible Oils - Sunterra Brand",
    shortDesc: "Premium range of refined edible oils available in bulk and retail packaging",
    description: "EYCO's Sunterra brand offers a complete portfolio of refined edible oils including sunflower, canola, soybean, extra virgin olive oil, pomace oil, and palm oil. Available in both bulk packaging for industrial clients and convenient retail sizes for commercial and consumer use.",
    image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/bvqsc54y_Refined%20Edible%20Oils%20-%20Sunterra%20Brand.jpeg",
    features: [
      "Six premium oil varieties (Sunflower, Canola, Soybean, Extra Virgin Olive, Pomace, Palm)",
      "Refined for maximum purity and quality",
      "Rich in essential nutrients",
      "Versatile cooking applications",
      "Quality assured Sunterra brand",
      "Flexible packaging options for all needs"
    ],
    applications: ["Home cooking", "Commercial kitchens", "Food processing", "Industrial manufacturing"],
    oilTypes: [
      { name: "Sunflower Oil", desc: "Light, versatile cooking oil" },
      { name: "Canola Oil", desc: "Heart-healthy, low saturated fat" },
      { name: "Soybean Oil", desc: "All-purpose cooking oil" },
      { name: "Extra Virgin Olive Oil", desc: "Premium grade, cold-pressed" },
      { name: "Pomace Oil", desc: "High-temperature cooking" },
      { name: "Palm Oil", desc: "Rich texture, high stability" }
    ],
    packaging: {
      bulk: [
        {
          type: "Flexi Bags",
          description: "Flexible bulk liquid containers for large-scale distribution",
          capacity: "Up to 24,000 liters",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/61xiumpo_flexibags.jpg"
        },
        {
          type: "IBC Tanks",
          description: "Intermediate Bulk Containers for safe, efficient storage and transport",
          capacity: "1,000 liters standard",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/th1ef9kj_IBC%20tank.jpg"
        }
      ],
      retail: [
        {
          type: "PET Bottles",
          sizes: ["1 Liter", "5 Liters"],
          description: "Lightweight, convenient plastic bottles for everyday use",
          images: {
            "1L": "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/tevq4np8_1LT_PET_ELIPS_SUNTRpsd.jpg",
            "5L": "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/lxxyim0r_5LT_PET_ELIPSMISIR.jpg"
          },
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/tevq4np8_1LT_PET_ELIPS_SUNTRpsd.jpg"
        },
        {
          type: "Metal Tins",
          sizes: ["5 Liters"],
          description: "Durable tin containers for extended shelf life",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/f9qse1tu_Sunflower%20tin.jpg"
        }
      ]
    }
  },
  {
    id: 6,
    title: "Olive Oil",
    shortDesc: "Premium Mediterranean olive oils — from extra virgin to pomace — sourced from the finest groves of Turkiye and Spain",
    description: "Olive oil is one of the healthiest fats on earth. Rich in monounsaturated fatty acids and powerful antioxidants, it supports heart health, reduces inflammation, and is a cornerstone of the Mediterranean diet. Our olive oil range is sourced from select groves in Turkiye and Spain, and processed to preserve maximum flavor, aroma, and nutritional value.",
    image: "https://customer-assets.emergentagent.com/job_72cdbc16-0f80-4f74-9483-fd8ad1e9a069/artifacts/0n6qsvrs_olive%20oil%20tin.jpg",
    features: [
      "Rich in heart-healthy monounsaturated fatty acids",
      "Loaded with antioxidants and polyphenols",
      "Cold-pressed options available",
      "Sourced from premium groves in Turkiye and Spain",
      "Multiple grades for every application",
      "Private label services available"
    ],
    applications: ["Cooking & frying", "Salad dressings", "Food processing", "Cosmetics & skincare", "Restaurant & hospitality"],
    oliveOilTypes: [
      { name: "Extra Virgin Olive Oil", desc: "First cold-pressed, highest quality with rich flavor and aroma" },
      { name: "Pure Olive Oil", desc: "Blend of refined and virgin olive oil, versatile for all cooking" },
      { name: "Refined Olive Oil", desc: "Light and neutral flavor, ideal for high-heat cooking" },
      { name: "Pomace Olive Oil", desc: "Extracted from olive pulp, excellent for deep frying and industrial use" }
    ],
    packaging: {
      bulk: [
        {
          type: "Flexi Tanks",
          description: "Flexible bulk liquid containers for large-scale distribution",
          capacity: "Up to 24,000 liters",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/61xiumpo_flexibags.jpg"
        },
        {
          type: "IBC Tanks",
          description: "Intermediate Bulk Containers for safe, efficient storage and transport",
          capacity: "1,000 liters standard",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/th1ef9kj_IBC%20tank.jpg"
        }
      ]
    },
    retailImages: [
      {
        src: "https://customer-assets.emergentagent.com/job_72cdbc16-0f80-4f74-9483-fd8ad1e9a069/artifacts/0n6qsvrs_olive%20oil%20tin.jpg",
        alt: "Sunterra Extra Virgin Olive Oil - 5L Metal Tin"
      },
      {
        src: "https://customer-assets.emergentagent.com/job_72cdbc16-0f80-4f74-9483-fd8ad1e9a069/artifacts/m1u3pl6a_sunterra%20olive%20oil.png",
        alt: "Sun Terra Mediterranean Extra Virgin Olive Oil - Glass Bottles"
      }
    ]
  },
  {
    id: 7,
    title: "Crude Glycerin (Biodiesel-Derived)",
    shortDesc: "A versatile industrial-grade glycerin produced as a co-product of biodiesel manufacturing",
    description: "A versatile industrial-grade glycerin produced as a co-product of biodiesel manufacturing, our Crude Glycerin is a brown, viscous liquid with a glycerol content of 60-100% and a high flash point of 176 C, making it safe and easy to handle under standard conditions.",
    image: "https://customer-assets.emergentagent.com/job_72cdbc16-0f80-4f74-9483-fd8ad1e9a069/artifacts/dzqb6xly_crude%20glycerin.png",
    features: [
      "Glycerol content: 60-100%",
      "Density: 1.26 g/cm3 at 20 C",
      "High flash point: 176 C",
      "Miscible in water",
      "Readily biodegradable and non-hazardous",
      "Compliant with EINECS, TSCA, IECSC and more"
    ],
    applications: ["Refinery feedstock", "Dust suppression", "Wastewater treatment", "Animal feed supplement", "Industrial processing"],
    keyProperties: [
      { property: "Glycerol Content", value: "60-100%" },
      { property: "Density", value: "1.26 g/cm3 at 20 C" },
      { property: "Flash Point", value: "176 C" },
      { property: "Solubility", value: "Miscible in water" },
      { property: "Biodegradability", value: "Readily biodegradable" },
      { property: "Transport Classification", value: "Non-hazardous (DOT / IMDG / IATA)" }
    ],
    safetyInfo: "Classified as non-hazardous under sea transport regulations. Presents no significant health risks under normal handling conditions. Not considered an irritant, sensitizer, mutagen, or carcinogen.",
    packaging: {
      bulk: [
        {
          type: "Flexi Tanks",
          description: "Flexible bulk liquid containers for large-scale distribution",
          capacity: "Up to 24,000 liters",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/61xiumpo_flexibags.jpg"
        },
        {
          type: "IBC Tanks",
          description: "Intermediate Bulk Containers for safe, efficient storage and transport",
          capacity: "1,000 liters standard",
          image: "https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/th1ef9kj_IBC%20tank.jpg"
        }
      ]
    },
    documentation: "COA, SDS, and technical documentation available upon request."
  }
];

export const companyInfo = {
  name: "EGESEA",
  tagline: "Excellence in Edible Oils",
  description: "EGESEA is a leading provider of premium edible oils and oil derivatives, committed to delivering the highest quality products for both consumer and industrial applications.",
  mission: "To provide sustainable, high-quality edible oils and derivatives that meet the evolving needs of our customers while maintaining the highest standards of food safety and environmental responsibility.",
  values: [
    {
      title: "Quality First",
      description: "We maintain rigorous quality control standards throughout our production process",
      icon: "shield-check"
    },
    {
      title: "Sustainability",
      description: "Committed to environmentally responsible sourcing and production practices",
      icon: "leaf"
    },
    {
      title: "Innovation",
      description: "Continuously improving our processes and products to meet market demands",
      icon: "lightbulb"
    },
    {
      title: "Customer Focus",
      description: "Building lasting relationships through exceptional service and support",
      icon: "users"
    }
  ],
  stats: [
    { value: "25+", label: "Years Experience" },
    { value: "50+", label: "Countries Served" },
    { value: "100K+", label: "Tons Annually" },
    { value: "99.9%", label: "Quality Rating" }
  ]
};

export const contactInfo = {
  email: "ugurermis@eyco.com.tr",
  phone: "+90 (532) 6478140",
  address: "Izmir, Turkey"
};
